import React from "react";
import "./TrustAndExcellenceStyle.scss";
import { trustAndExcellenceTextContent } from "./constant/index";

const TrustAndExcellenceTabsContent = ({ images }) => {
  return (
    <div className="trust-and-excellence-tabs-content-box">
      {images.map((item, index) => (
        <div className="img-box" key={index}>
          <img src={item.imageSrc} alt="Image" />
        </div>
      ))}
    </div>
  );
};

export default TrustAndExcellenceTabsContent;
